import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { getAuthHeader, getAuthUrl } from '../../../utils';
import { useEffect } from 'react';

export const userInfoAxios = async () => {
    const url = getAuthUrl() + 'connect/userinfo';
    const res = await axios.get(url, { headers: getAuthHeader() });
    return res.data;
};

export const useUserInfoQuery = (onSuccess: (userInfo: any) => void) => {
    const isEnabled = () => {
        try {
            return !!getAuthUrl();
        } catch {}
    };

    const { isLoading, data } = useQuery({
        queryKey: ['userinfo'],
        queryFn: () => userInfoAxios(),
        enabled: !!isEnabled(),
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (data) {
            onSuccess(data);
        }
    }, [data]);

    return {
        isUserInfoLoading: isLoading,
        userInfoData: data,
    };
};
